module.exports = __webpack_public_path__ + "img/111.919b562d.jpg";